import React from 'react';
import { TopBar, Footer } from './components/Layout';
import { Hero } from './components/Hero';
import { OpeningHook, PainAmplification, PainLoopDiagram } from './components/StorySections';
import { MechanismReveal, ProductIntro, ChaptersGrid } from './components/ProductSections';
import { BonusStack, ValueStack, Guarantee, Urgency } from './components/OfferSections';
import { Testimonials } from './components/SocialProofSections';
import { StrongClose, FinalCTA } from './components/ClosingSections';
import { RecentPurchaseToast } from './components/RecentPurchaseToast';
export function App() {
  return <div className="min-h-screen bg-navy-900 font-sans selection:bg-teal-500 selection:text-navy-900" data-id="element-0">
      <TopBar data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />
        <OpeningHook data-id="element-4" />
        <PainAmplification data-id="element-5" />
        <PainLoopDiagram data-id="element-6" />
        <MechanismReveal data-id="element-7" />
        <ProductIntro data-id="element-8" />
        <ChaptersGrid data-id="element-9" />
        <BonusStack data-id="element-10" />
        <ValueStack data-id="element-11" />
        <Guarantee data-id="element-12" />
        <Urgency data-id="element-13" />
        <Testimonials data-id="element-14" />
        <StrongClose data-id="element-15" />
        <FinalCTA data-id="element-16" />
      </main>

      <Footer data-id="element-17" />
      <RecentPurchaseToast data-id="element-18" />
    </div>;
}